import React, { useEffect, useRef } from 'react';
import { getProduct } from '../../product-catalog/productPresentation';
import { assetUrl } from '../shared/assetUrl';

export default function LessonPlayer({ lesson, onClose, t }) {
  const headingRef = useRef(null);

  useEffect(() => {
    headingRef.current?.focus({ preventScroll: true });
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    headingRef.current?.scrollIntoView({ behavior: reducedMotion ? 'instant' : 'smooth', block: 'start' });
  }, [lesson.id]);

  return (
    <section className="learning-player" aria-labelledby="learning-video-title">
      <div className="learning-player-header">
        <div>
          <span className="learning-eyebrow">{getProduct(lesson.productId).name}</span>
          <h2 ref={headingRef} id="learning-video-title" tabIndex={-1}>
            {t(lesson.titleKey || 'learning.videoTitle', { product: getProduct(lesson.productId).name })}
          </h2>
          <p>{t(lesson.videoDescriptionKey || 'learning.videoDescription')}</p>
        </div>
        <button type="button" className="learning-close" onClick={onClose} aria-label={t('learning.closeVideo')}>
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <video
        key={lesson.id}
        controls
        playsInline
        preload="metadata"
        poster={assetUrl(lesson.poster)}
        aria-label={t(lesson.titleKey || 'learning.videoTitle', { product: getProduct(lesson.productId).name })}
      >
        <source src={assetUrl(lesson.video)} type="video/mp4" />
        {t('learning.videoFallback')}
      </video>
    </section>
  );
}

